<template>
  <div class="card p-3 shadow">
    <h4 class="font-weight-bolder text-primary pb-3">پربازدیدترین محصولات</h4>
    <table class="table text-center">
      <thead>
      <tr>
        <th scope="col">نام محصول</th>
        <th scope="col">بازدید</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(item,index) in mostViewedProducts">
        <td>{{ item.name }}</td>
        <td class="text-center">{{ getProductViewCount(item) }}</td>
      </tr>

      </tbody>
    </table>
    <div class="text-center mx-auto">
      <pagination class="mx-auto" :meta="pagination" :on-change-page="changePage"/>
    </div>
  </div>
</template>

<script>
import Pagination from "../../dashboard/Pagination.vue";

export default {
  name: "StatisticMostViewedProduct",
  components: {Pagination},
  data() {
    return {
      form: {
        page: 1
      },
      pagination: [],
      mostViewedProducts: [],
    }
  },
  methods: {
    getMostViewedProducts(form) {
      this.$store.dispatch('Statistic/mostViewedProduct', form).then(res => {
        let baseData = res.data.data;
        this.mostViewedProducts = baseData.data
        this.pagination = baseData.meta
      });
    },
    changePage(page) {
      this.form.page = page
      this.getMostViewedProducts(this.form)
    },
    getProductViewCount(product){
      let productMeta = product.meta
      if (productMeta != undefined) {
        let viewCount = productMeta.find((item) => {
          return item.name === 'view_count';
        });
        return viewCount == undefined ? null : viewCount.value
      }
      return null
    }
  },
  mounted() {
    this.getMostViewedProducts(this.form)
  }
}
</script>

<style scoped>

</style>